import * as CONSTS from 'redux/constants';
import * as reduxUtil from 'redux/utils/reducers';

const stateKeys = {
  livenessCheck: 'livenessCheck',
  verifySecureMe: 'verifySecureMe'
};

const initialState = {
  idvPage: {
    loading: false,
    data: {},
    error: null
  },
  documents: {
    loading: false,
    data: [],
    error: null
  },
  verify: {
    loading: false,
    error: null,
    success: false
  },
  livenessCheck: reduxUtil.initializeObject(),
  allDataFetched: false,
  selectedCountry: '',
  verifySecureMe: reduxUtil.initializeObject()
};

const reducer = (state = initialState, action) => {
  const { data, error } = action?.payload || {};

  switch (action.type) {
    case CONSTS.SET_ALL_IDV_DATA_FETCHED:
      return {
        ...state,
        allDataFetched: action.payload
      };
    case CONSTS.GET_IDV_PAGE_START:
      return {
        ...state,
        idvPage: {
          ...state.idvPage,
          loading: true
        }
      };
    case CONSTS.GET_IDV_PAGE_SUCCESS:
      return {
        ...state,
        idvPage: {
          ...state.idvPage,
          data: action.payload.data,
          loading: false,
          error: null
        }
      };
    case CONSTS.GET_IDV_PAGE_FAIL:
      return {
        ...state,
        idvPage: {
          ...state.idvPage,
          error: action.payload.error,
          loading: false
        }
      };
    case CONSTS.RESET_IDV_DOCUMENTS:
      return {
        ...state,
        documents: {
          ...state.documents,
          data: []
        }
      };
    case CONSTS.GET_IDV_DOCUMENTS_START:
      return {
        ...state,
        documents: {
          ...state.documents,
          loading: true
        }
      };
    case CONSTS.GET_IDV_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: {
          ...state.documents,
          data: action.payload.data,
          loading: false,
          error: null
        }
      };
    case CONSTS.GET_IDV_DOCUMENTS_FAIL:
      return {
        ...state,
        documents: {
          ...state.documents,
          data: [],
          error: action.payload.error,
          loading: false
        }
      };
    case CONSTS.LIVENESS_CHECK_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.livenessCheck });
    case CONSTS.LIVENESS_CHECK_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.livenessCheck, error });
    case CONSTS.LIVENESS_CHECK_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: stateKeys.livenessCheck, data });
    case CONSTS.VERIFY_DOCUMENTS_START:
      return {
        ...state,
        verify: {
          error: null,
          loading: true,
          success: null
        }
      };
    case CONSTS.VERIFY_DOCUMENTS_FAIL:
      return {
        ...state,
        verify: {
          error: action.payload.error,
          loading: false,
          success: false
        }
      };
    case CONSTS.VERIFY_DOCUMENTS_SUCCESS:
      return {
        ...state,
        verify: {
          error: null,
          loading: false,
          success: true
        }
      };
    case CONSTS.SET_SELECTED_COUNTRY:
      return {
        ...state,
        selectedCountry: action.payload
      };
    case CONSTS.VERIFY_SECUREME_FLOW_START:
      return reduxUtil.updateStartAction({ state, key: stateKeys.verifySecureMe });
    case CONSTS.VERIFY_SECUREME_FLOW_FAIL:
      return reduxUtil.updateFailAction({ state, key: stateKeys.verifySecureMe, error });
    case CONSTS.VERIFY_SECUREME_FLOW_SUCCESS:
      return reduxUtil.updateSuccessAction({
        state,
        key: stateKeys.verifySecureMe,
        data
      });
    default:
      return state;
  }
};

export default reducer;
